import React from "react";
import Navbar from "../components/Navbar/Navbar";
import PTEIntegratedScoring from "../components/PTEGuide/PTEIntegratedScoring";

const PTEGuide = () => {
  return (
    <>
      <Navbar />
      <PTEIntegratedScoring />
    </>
  );
};

export default PTEGuide;
